import {
  Edit,
  SimpleForm,
  TextInput,
  ImageInput,
  ImageField,
  BooleanInput
} from "react-admin";
import {
  hasValue,
  cnpj
} from "../../utils/schemas";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid } from "@mui/material";
import EditTitle from "../../ui/edit-title";
import CustomSaveToolbar from "../../ui/custom-save-toolbar";
import MaskTextInput from "../../inputs/mask-text-input";

const Schema = Yup.object(
{
  name: hasValue(),
  register_number: cnpj()
});

const EnterpriseEdit = () =>
{
  return (
    <Edit
      title={<EditTitle subtitle="Editar Empresa: " source="name" />}
      redirect="list"
      mutationMode="pessimistic" >
      <SimpleForm
        noValidate
        resolver={yupResolver(Schema)}
        toolbar={<CustomSaveToolbar />} >
        <Grid container columnSpacing={2} width="100%">
          <Grid size={{ xs: 1 }}>
            <TextInput source="id" label="Id" fullWidth disabled />
          </Grid>
          <Grid size={{ xs: 5 }}>
            <TextInput source="name" label="Nome" fullWidth isRequired />
          </Grid>
          <Grid size={{ xs: 6 }} />

          <Grid size={{ xs: 6 }} style={{ marginBottom: 20 }}>
            <MaskTextInput source="register_number" label="CNPJ" mask="##.###.###/####-##" fullWidth isRequired />
          </Grid>
          <Grid size={{ xs: 6 }} />

          <Grid size={{ xs: 6 }}>
            <ImageInput source="image" label="Logo (.jpg)" accept={{ 'image/jpg,image/jpeg': ['.jpeg', '.jpg'] }} fullWidth >
              <ImageField source="src" title="title" />
            </ImageInput>
          </Grid>
          <Grid size={{ xs: 6 }} />

          <Grid size={{ xs: 6 }}>
            <BooleanInput source="active" label="Ativo" />
          </Grid>
          <Grid size={{ xs: 6 }} />
        </Grid>
      </SimpleForm>
    </Edit>
  );
};

export default EnterpriseEdit;
